import { render, staticRenderFns } from "./SmsTemplate.vue?vue&type=template&id=9ba9d87c&"
import script from "./SmsTemplate.vue?vue&type=script&lang=ts&"
export * from "./SmsTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports